import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Loader from './../../shared/loader'
import CryptoJS from 'crypto-js'
import download from 'downloadjs'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
	name: 'rackauditreport',
	components: {
		Paginate,
		Pagination,
		JsonExcel,
		DatePicker,
		JsonExcel,
		Loader,
		BasicSelect
	},
	data() {
		return {
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			listMerchantData:[],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// totalRows:0,
			// currentPage: 0,
			// getNewWarehouseData:'',
			listAuditData: [],
			listAuditDatacsv: [],
			modalShow: false,
			modalMessageShow: false,
			displayMsg: false,
			successErrorMsg: "",
			MerchantErr:"",
			fromDateFlt: "",
			toDateFlt: "",
			// totalPage: 0,
			// pageNo: 0,
			listClientData: [],
			listWarehouseData: [],
			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',
			ClientErr: '',
			WarehouseErr: '',
			ClientErr: '',
			searchFlag: false,
			showSelectMerchant:false,
			showSelectWarehouse: false,
			showSelectClient: false,
			orderCancelShow: false,
			loginuserid: '',
			isLoading: false,
			// perPage: 10,
			formattedDate: '',
			user_type: '',
			showAuditDetails: false,
			AuditSessionData: [],
			productid: '',
			rackid: '',
			resultCount: 0,
			fromdate: '',
			todate: '',
			currentAuditData: [],
			auditDetailsCsv: [],
			isLoadingforxls: false,
			item:{},
		    listMerchantData1:[],
		    merchantList:[],
			merchant:'',
		}
	},
	filters: {
		moment: function(dates) {
			return moment(dates).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		this.calldateFunction()
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.reportname = this.$t('editedjson.rackAuditReport');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.loginuserid = userdetail.userid;
		this.user_type = userdetail.utype;
		this.pageNo = 0;

		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantData();
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant= true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantData();
				this.showSelectMerchant= true;
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.showSelectMerchant= true;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

	}, // End computed
	methods: {
		calldateFunction: function() {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.toDateFlt = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.fromDateFlt = dt;
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			this.getAuditListForXLS(3)
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client ||this.clientid == this.client ) {
		// 		this.clientid = this.client;
		// 		this.merchant = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantData();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 				this.Merchant=''
		// 			}
		// 		} else {
		// 			this.getMerchantData();
		// 			this.merchant=''
		// 			// if (this.warehouseid && this.clientid) {
		// 			// 	//this.getAuditList();
		// 			// }
		// 		}
		// 	}

		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {

		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		getAuditList(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			// this.ClientErr = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}

			this.isLoading = true;

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				merchant:this.merchant,
				fromdate: this.dateFormat1(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				productid: this.productid,
				rackid: this.rackid,
				csvData: csvCheck,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRackAuditListing',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 1) {
						this.show = true;
						this.download = false;
						this.listAuditDatacsv = [];
						this.csvFields = {
							'rackid': this.$t('common.rackID'),
							'starttime': this.$t('auditReport.auditStartDate'),
							'endtime': this.$t('auditReport.auditCompletedDate'),
							'userid': this.$t('auditReport.auditBy'),
							'systemstock': this.$t('auditReport.systemStock'),
							'merchantname':this.$t('pickingReport.table.columns.merchantName'),
							'matchedqty': this.$t('auditReport.matchedQty'),
							'scannedqty': this.$t('auditReport.scannedQty'),
							'excessqty':  this.$t('common.excessQty'),
							'shortqty': this.$t('common.shortQty'),
						};
						this.listAuditDatacsv = result.data.data.filter(function(el) { return delete el.isapproved}); 
						var dateFilter = ['starttime', 'endtime'];
						var skipFilter = ['sessionid','merchantid'];
						csvHelper.data.jsonToCSV(this.$t('editedjson.rackAuditReport'), this.listAuditDatacsv, this.csvFields, dateFilter, skipFilter, dataFilter);

					} else {
						this.listAuditData = result.data.data;
					
						if (result.data.errorCode == -1) {
							this.resultCount = 0;
							this.$alertify.error(result.data.msg);
						} else {
							this.totalRows = result.data.count
							this.resultCount = result.data.count
							if (this.totalRows == 0) {
								this.totalPage = 0
							} else if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10)
							}
						}
					}

					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getAuditListForXLS(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			// this.ClientErr = '';
			var dataFilter = {};
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				fromdate: this.dateFormat1(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				productid: this.productid,
				rackid: this.rackid,
				csvData: csvCheck,
				merchant:this.merchant,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRackAuditListing',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('common.rackID')] = 'rackid',
							this.csvFieldsForXls[this.$t('pickingReport.table.columns.merchantName')] = 'merchantname',
							this.csvFieldsForXls[this.$t('auditReport.auditStartDate')] = 'starttime',
							this.csvFieldsForXls[this.$t('auditReport.auditCompletedDate')] = 'endtime',
							this.csvFieldsForXls[this.$t('auditReport.auditBy')] = 'userid',
							this.csvFieldsForXls[this.$t('auditReport.systemStock')] = 'systemstock',
							this.csvFieldsForXls[this.$t('auditReport.matchedQty')] = 'matchedqty',
							this.csvFieldsForXls[this.$t('auditReport.scannedQty')] = 'scannedqty',
							this.csvFieldsForXls[this.$t('common.excessQty')] =  'excessqty',
							this.csvFieldsForXls[this.$t('common.shortQty')] =   'shortqty'


							this.listReportDataforxls = result.data.data;

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}

				}, error => {
					console.error(error);
				})
		},
		// getMerchantData() {
		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
			
		// 	this.input = ({
		// 		'clientid': this.client,
		// 		"limit": 16,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'merchantMaster',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listMerchantData = result.data.rows;
		// 			console.log(this.listMerchantData)
		// 		}, error => {
		// 			console.error(error);
		// 		})
		// },
		getMerchantData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
                       this.item={
						   value:'',
						   text:''
					   };
						this.listMerchantData1=[{value:'',text:this.$t('common.selectMerchantPlaceHolder')}];
					    this.listMerchantData.forEach(ele=>{
						this.listMerchantData1.push({
							"value":ele.merchantid,
							"text":ele.merchantname
						})
					   })
					}
				}, error => {
					console.error(error)
				})
		},
		reset(){
			this.item={}
		},
		onSelect(item){
			this.item=item
			this.merchant=item.value
		},
		getAuditListDetails(getData, iscsv) {
			var dataFilter = {};
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			this.show = false;
			this.download = true;
			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.clientError');
				return false;
			}
			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.warehouseError');
				return false;
			}
			this.currentAuditData = getData;
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: localStorage.getItem("selectedWarehouse"),
				auditid: getData.sessionid
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRackAuditDetails',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (iscsv == 1) {
						this.csvFields = {
							'productid': this.$t('common.productId'),
							'eancode': this.$t('common.eanCode'),
							'systemqty': this.$t('auditReport.systemQty'),
							'matchedqty': this.$t('auditReport.matchQty'),
							'scannedqty': this.$t('auditReport.scannedQty'),
							'excessqty': this.$t('common.excessQty'),
							'excessproduct': this.$t('auditReport.excessProductQty'),
							'shortqty': this.$t('common.shortQty')
						};
						var dateFilter = [];
						var skipFilter = [];
						this.auditDetailsCsv = [];
						this.auditDetailsCsv = result.data.data;
						csvHelper.data.jsonToCSV(this.$t('editedjson.RackAuditDetails') + getData.rackid + '_', this.auditDetailsCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

					} else {
						this.showAuditDetails = true;
						this.AuditSessionData = result.data.data;
					}

					this.isLoading = false;
				}, error => {
					console.error(error);
				});
		},

		onPageChange(page) {
			this.currentPage = page;
			this.getAuditList()
		},
		AuditListing() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.resultCount = 0;
			this.totalRows = 0;
			this.searchFlag = true;
			this.getAuditList(2);
		},
		resetAuditSerach() {
			this.merchant=''
			this.show = false;
			this.download = true;
			this.fromDateFlt = "";
			this.toDateFlt = "";
			this.listAuditData = [];
			this.pageNo = 0;
			this.totalPage = 0;
			this.resultCount = 0;
			this.totalRows = 0;
			this.searchFlag = false;
			this.rackid = '';
			this.productid = '';
			this.$validator.reset();
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
			this.item={
				value:'',
				text:''
			};
			// this.listMerchantData1=[{value:'',text:this.$t('common.merchantPlaceholder')}];
			// this.getAuditList();
		},
		async validatevalues() {
			try {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.AuditListing();
					} else {
						console.log("not valid")
					}
				})
			}
			catch (err) {
				this.isLoading = false;
				this.$alert(err, "", "error");
				console.log(err);
			}
		},
		
	} // end methods

}


// WEBPACK FOOTER //
// ./src/views/components/reports/rackauditreport/rackauditreport.component.js